export class IzipayPagePresenter {
  form_paygateway = {
    title: 'Recuerda Activas tus compras por internet',
    amount: '0.00',
    currency: 'S/.',
    subtitle: '',
    subtitle2: '',
  }
}
